import APIConstant from 'constants/ApiConstant';
import { CLIENT_ID, LOGGED_IN_USER_ID, LOGGED_IN_USER_NAME, ROLE_ID, USER_AUTHENTICATION_TOKEN } from 'constants/AuthConstant';
import { makeAutoObservable, runInAction } from 'mobx';
import { postRequest } from 'utils/apiUtils';
import { isValidArray } from 'utils/utilities';

class LoginStore {
	isLoading = false;
	isLogInSuccess = false;

	constructor() {
		makeAutoObservable(this);
	}

	handleUserLogin = async data => {
		try {
			this.isLoading = true;
			const { response } = await postRequest({
				url: APIConstant.USER_LOGIN,
				payload: data,
			});
			const { result, success } = response;

			if (success && isValidArray(result)) {
				const [{ token_id, user_id, first_name, last_name, client_id, role_id }] = result;
				sessionStorage.setItem(USER_AUTHENTICATION_TOKEN, token_id);
				sessionStorage.setItem(CLIENT_ID, client_id);
				sessionStorage.setItem(LOGGED_IN_USER_ID, user_id);
				sessionStorage.setItem(LOGGED_IN_USER_NAME, first_name); // Store only first name
				sessionStorage.setItem(ROLE_ID, role_id)

				runInAction(() => {
					this.isLogInSuccess = true;
					this.isLoading = false;
				});
			}
		} catch (error) {
			runInAction(() => {
				this.isLogInSuccess = false;
				this.isLoading = false;
			});
		}
	};

	resetLoginStore = () => {
		runInAction(() => {
			this.isLoading = false;
			this.isLogInSuccess = false;
		});
	};
}

export default LoginStore;
